// apps/tutorify/src/modules/logify/services/logify.api.ts
import { request } from "../../../api/client";
import type {
  Observation,
  CreateObservationPayload,
  UpdateObservationPayload,
  ObservationFilters,
  StudentObservationsResponse,
} from "../types";

export function getObservations(filters: ObservationFilters = {}): Promise<Observation[]> {
  const qs = new URLSearchParams();
  if (filters.classRoomId != null) qs.set("classRoomId", String(filters.classRoomId));
  if (filters.studentId != null) qs.set("studentId", String(filters.studentId));
  if (filters.category) qs.set("category", filters.category);
  if (filters.sentiment) qs.set("sentiment", filters.sentiment);
  if (filters.startDate) qs.set("startDate", filters.startDate);
  if (filters.endDate) qs.set("endDate", filters.endDate);
  if (filters.source) qs.set("source", filters.source);
  if (filters.calendarEventId != null) qs.set("calendarEventId", String(filters.calendarEventId));
  if (filters.limit != null) qs.set("limit", String(filters.limit));
  if (filters.offset != null) qs.set("offset", String(filters.offset));
  const query = qs.toString();
  return request<Observation[]>(`/logify/observations${query ? `?${query}` : ""}`);
}

export function getObservation(id: number): Promise<Observation> {
  return request<Observation>(`/logify/observations/${id}`);
}

export function createObservation(payload: CreateObservationPayload): Promise<Observation> {
  return request<Observation>("/logify/observations", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateObservation(id: number, payload: UpdateObservationPayload): Promise<Observation> {
  return request<Observation>(`/logify/observations/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function deleteObservation(id: number): Promise<Observation> {
  return request<Observation>(`/logify/observations/${id}`, {
    method: "DELETE",
  });
}

export function getStudentObservations(studentId: number): Promise<StudentObservationsResponse> {
  return request<StudentObservationsResponse>(`/logify/observations/student/${studentId}`);
}

export function getClassObservations(classRoomId: number): Promise<Observation[]> {
  return request<Observation[]>(`/logify/observations/class/${classRoomId}`);
}
